import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  createTransform,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import { normalizeOpsUser } from "../utils/normalizeOpsUser";

const rootReducer = combineReducers({
  auth: authReducer,
});

/** Keep persisted auth.user on the backend Admin field shape (e.g. last_login_at). */
const authUserTransform = createTransform(
  (inboundState) => {
    if (!inboundState?.user) return inboundState;
    const user = normalizeOpsUser(inboundState.user);
    return user ? { ...inboundState, user } : inboundState;
  },
  (outboundState) => {
    if (!outboundState?.user) return outboundState;
    const user = normalizeOpsUser(outboundState.user);
    return user ? { ...outboundState, user } : outboundState;
  },
  { whitelist: ["auth"] }
);

const persistConfig = {
  key: "simcollect-admin",
  storage,
  whitelist: ["auth"],
  transforms: [authUserTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
